var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogOut = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.5C6.60218 5.5 6.22064 5.65804 5.93934 5.93934C5.65804 6.22064 5.5 6.60218 5.5 7V21C5.5 21.3978 5.65804 21.7794 5.93934 22.0607C6.22064 22.342 6.60218 22.5 7 22.5H11C11.2761 22.5 11.5 22.7239 11.5 23C11.5 23.2761 11.2761 23.5 11 23.5H7C6.33696 23.5 5.70107 23.2366 5.23223 22.7678C4.76339 22.2989 4.5 21.663 4.5 21V7C4.5 6.33696 4.76339 5.70107 5.23223 5.23223C5.70107 4.76339 6.33696 4.5 7 4.5H11C11.2761 4.5 11.5 4.72386 11.5 5C11.5 5.27614 11.2761 5.5 11 5.5H7ZM17.6464 8.64645C17.8417 8.45118 18.1583 8.45118 18.3536 8.64645L23.3536 13.6464C23.5488 13.8417 23.5488 14.1583 23.3536 14.3536L18.3536 19.3536C18.1583 19.5488 17.8417 19.5488 17.6464 19.3536C17.4512 19.1583 17.4512 18.8417 17.6464 18.6464L21.7929 14.5H11C10.7239 14.5 10.5 14.2761 10.5 14C10.5 13.7239 10.7239 13.5 11 13.5H21.7929L17.6464 9.35355C17.4512 9.15829 17.4512 8.84171 17.6464 8.64645Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogOut, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/log-out.44e9f2f9.svg";
export { ForwardRef as ReactComponent };